import React from 'react';
import { Users, BookOpen, Star, Award } from 'lucide-react';
export function SocialProofBar() {
  return <div className="bg-white text-brand-text py-3 px-4 border-y-2 border-brand-section shadow-sm" data-id="element-233">
      <div className="max-w-5xl mx-auto flex flex-row items-center justify-center md:justify-between gap-3 md:gap-6 flex-wrap" data-id="element-234">
        <div className="flex items-center gap-2" data-id="element-235">
          <Users className="w-5 h-5 text-brand-primary shrink-0" data-id="element-236" />
          <div className="flex items-baseline gap-1.5 leading-tight" data-id="element-237">
            <span className="text-sm md:text-base font-black text-brand-text" data-id="element-238">
              +2.500
            </span>
            <span className="text-[10px] md:text-xs text-brand-steel font-bold uppercase tracking-wide" data-id="element-239">
              técnicos
            </span>
          </div>
        </div>

        <div className="hidden md:block w-px h-6 bg-brand-section" data-id="element-240"></div>

        <div className="flex items-center gap-2" data-id="element-241">
          <BookOpen className="w-5 h-5 text-brand-primary shrink-0" data-id="element-242" />
          <div className="flex items-baseline gap-1.5 leading-tight" data-id="element-243">
            <span className="text-sm md:text-base font-black text-brand-text" data-id="element-244">
              4 en 1
            </span>
            <span className="text-[10px] md:text-xs text-brand-steel font-bold uppercase tracking-wide" data-id="element-245">
              sistema
            </span>
          </div>
        </div>

        <div className="hidden md:block w-px h-6 bg-brand-section" data-id="element-246"></div>

        <div className="flex items-center gap-2" data-id="element-247">
          <Award className="w-5 h-5 text-brand-primary shrink-0" data-id="element-248" />
          <div className="flex items-baseline gap-1.5 leading-tight" data-id="element-249">
            <span className="text-sm md:text-base font-black text-brand-text" data-id="element-250">
              14 días
            </span>
            <span className="text-[10px] md:text-xs text-brand-steel font-bold uppercase tracking-wide" data-id="element-251">
              garantía
            </span>
          </div>
        </div>

        <div className="hidden md:block w-px h-6 bg-brand-section" data-id="element-252"></div>

        <div className="flex items-center gap-2" data-id="element-253">
          <div className="flex" data-id="element-254">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 text-brand-secondary fill-current" data-id="element-255" />)}
          </div>
          <div className="flex items-baseline gap-1.5 leading-tight" data-id="element-256">
            <span className="text-sm md:text-base font-black text-brand-text" data-id="element-257">
              4.9/5
            </span>
            <span className="text-[10px] md:text-xs text-brand-steel font-bold uppercase tracking-wide" data-id="element-258">
              LATAM
            </span>
          </div>
        </div>
      </div>
    </div>;
}